import axios from 'axios';

export function getVesselCampaigns() {
  return axios
    .get('/api/?entity=campaigns&action=getVesselCampaigns')
    .then(response => (response.data && response.data.data) || []);
}
